import JsBarcode from 'jsbarcode';

import { useTranslation } from 'react-i18next';

import useAlert from 'hooks/useAlert';

import { barcodeSizes, fontSizes, fontWeights } from './usePrintUtils';

const usePrintHelper = () => {
	const { showError } = useAlert();
	const { t } = useTranslation();

	const getTemplateFontSize = (fontSize, pageScale) => fontSizes[fontSize ?? 20] * pageScale;

	const getBarcodeSize = (barcodeSize) => barcodeSizes[barcodeSize ?? 20];

	const getTemplateFontWeight = (fontWeight) => fontWeights[fontWeight ?? 'regular'];

	const createBarcode = (value, options = null) => {
		if (!value) return;
		const canvas = document.createElement('canvas');

		try {
			JsBarcode(canvas, value, {
				...options
			});
		} catch {
			showError({
				message: t('errorMsg.barcodeValueIsNotValid', { value, format: options.format })
			});
			return null;
		}
		return {
			src: canvas.toDataURL(),
			canvasWidth: canvas.width,
			canvasHeight: canvas.height
		};
	};

	return {
		getTemplateFontSize,
		getTemplateFontWeight,
		getBarcodeSize,
		createBarcode
	};
};

export default usePrintHelper;
